import ModalProductCard from "./ModalProductCard"

export default ModalProductCard